import { formatPrice } from '../../../shared/helpers';

export const getSalestaxDisplayText = (salestax: number | 'ERROR' | null): string => {
  if (!salestax && salestax !== 0) return 'Calculated at checkout';
  if (salestax === 'ERROR') return 'Calculated when billed';
  return formatPrice(salestax);
};
